import {
  AD_SLOT_CARTINTERMIDIATE,
  AD_SLOT_CONFIRMATION,
  AD_SLOT_PDP_CROSSSELL,
  AD_SLOT_PDP_RX,
  AD_SLOT_SEARCH_CATEGORY_TOP,
  AD_SLOT_SEARCH_HITS_1,
  AD_SLOT_SEARCH_HITS_2,
} from 'shared/consts/adSlots'
import { type Sizes, SIZES_BY_ID } from 'views/consts/adSlots'

export const PLACEHOLDER_SIZES_BY_ID: Sizes = {
  ...SIZES_BY_ID,
  // search page (category product listing): top
  [AD_SLOT_SEARCH_CATEGORY_TOP]: {
    large: { width: 0, height: 0 },
    small: { width: 0, height: 0 },
  },
  // search page: between search results (first)
  [AD_SLOT_SEARCH_HITS_1]: {
    large: { width: 0, height: 0 },
    small: { width: 0, height: 0 },
  },
  // search page: between search results (second)
  [AD_SLOT_SEARCH_HITS_2]: {
    large: { width: 0, height: 0 },
    small: { width: 0, height: 0 },
  },
  // product page: cross-sell widget
  [AD_SLOT_PDP_CROSSSELL]: {
    large: { width: 0, height: 0 },
    small: { width: 0, height: 0 },
  },
  // product page: RX message
  [AD_SLOT_PDP_RX]: {
    large: { width: 0, height: 0 },
    small: { width: 0, height: 0 },
  },
  // order confirmation page
  [AD_SLOT_CONFIRMATION]: {
    large: { width: 0, height: 0 },
    small: { width: 0, height: 0 },
  },
  // cart intermidiate page
  [AD_SLOT_CARTINTERMIDIATE]: {
    large: { width: 0, height: 0 },
    small: { width: 0, height: 0 },
  },
}
